import { HelpIndicator } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { globalEnv } from "~/global-env";
import { caseLinkIcon } from "./styles_vanilla.css";

/** Hover-revealed "View case" link for a linked onboarding case — the same icon as Positions. */
export const OnboardingViewCaseLink = ({ caseId }: { caseId: number }) => (
  <HelpIndicator id={`view-case-${caseId}-tooltip`} placement="top" content="View case">
    <Icon
      className={`${caseLinkIcon} hover-icon`}
      type="external-link"
      title="View case"
      color={Colors.Primary600}
      data-testid="case-details-icon"
      onClick={() =>
        window.open(
          `/canopy${globalEnv.complianceRoute}/case/${caseId}`,
          "_blank",
          "noopener,noreferrer",
        )
      }
    />
  </HelpIndicator>
);
